import React, { useEffect, useRef, useState } from 'react';
import UserEdit from './UserEdit';
import WebUniversal, { WebUniversalProps } from '../../system/WebUniversal';
import { Switch, Space, Button, Tooltip } from 'antd';
import RoleOrUserLicense from '../license/RoleOrUserLicense';
import { columnsheadId } from '../../universal/columnshead';
import RoleOrUserLicenseEx from '../license/RoleOrUserLicenseEx';
import fetchApi from '../../../utilsTsx/components/system/fetchApi';
import CustomSelect from '../../../utilsTsx/components/hooks/CustomSelect';
import UserConfigEdit from './UserConfigEdit';

//组件 User 
const User = (props: any) => {
    const apiId = 'user';
    const [modalUserLicense, setModalUserLicense] = useState(false);
    const [modalUserLicenseEx, setModalUserLicenseEx] = useState(false);
    const [modalUserConfig, setModalUserConfig] = useState(false);
    const [userInfo, setUserInfo] = useState<any>();
    const ref = useRef<any>(undefined);
    const [fetchData, setFetchData] = useState<any>();
    const [brandData, setBrandData] = useState<any>();
    const [userGroupData, setUserGroupData] = useState<any>();
    const [roleData, setRoleData] = useState<any>();
    const [sendPageData, setSendPageData] = useState<any>()

    useEffect(() => {
        let urlService;
        if (ref.current) {
            urlService = ref.current.defaultService
            setFetchData(() => ref.current.fetchData);
        }
        fetchApi.GET(urlService, {
            query: {
                apiId: 'brand',
                apiExtend: 'showList'
            }
        }).then(res => {
            if (res.success) {
                setBrandData([{ id: 'ALLITEM', brandName: '所有' }, ...res.data]);
            }
        })
        fetchApi.GET(urlService, {
            query: {
                apiId: 'userGroup',
                apiExtend: 'showList'
            }
        }).then(res => {
            if (res.success) {
                setUserGroupData([{ id: 'ALLITEM', userGroupName: '所有' }, ...res.data]);
            }
        })
        fetchApi.GET(urlService, {
            query: {
                apiId: 'role',
                apiExtend: 'showList'
            }
        }).then(res => {
            if (res.success) {
                setRoleData([{ id: 'ALLITEM', roleName: '所有' }, ...res.data]);
            }
        })
    }, []);

    const handleUserLicense = (record: any) => {
        const userId = record.id;
        setUserInfo({
            roleOrUserId: userId,
            itemName: record.userName
        });
        setModalUserLicense(true);
    };
    //子组件回调函数，关闭modal
    const onCloseModalUserLicense = (state: boolean) => {
        setModalUserLicense(false);
    };

    /** 子组件回调函数，关闭用户权根扩展 */
    const onCloseModalUserLicenseEx = () => {
        setModalUserLicenseEx(false);
    };

    /** 用户权限扩展 */
    const handleUserLicenseExpand = (record: any) => {
        const userId = record.id;
        setUserInfo({
            roleOrUserId: userId,
            itemName: record.userName
        });
        setModalUserLicenseEx(true)
    };

    /** 用户配置 */
    const handleUserConfig = (record: any) => {
        const userId = record.id;
        setUserInfo({
            userId
        });
        setModalUserConfig(true);
    };

    /**
     * 表头内容
     */
    const columnsHead = [
        {
            title: '用户名',
            dataIndex: 'userName',
            sorter: true,
        },
        {
            title: '用户组',
            dataIndex: 'userGroup',
            sorter: true,
            render: (text: any) => (text ? text.userGroupName : '')
        },
        {
            title: '角色',
            dataIndex: 'role',
            render: (val: any) => {
                let roleName = '';
                if (val) {
                    for (let i = 0; i < val.length; i++) {
                        const element = val[i];
                        if (roleName !== '') { roleName += ','; }
                        roleName += element?.roleName;
                    }
                }
                return roleName;
            }
        },
        {
            title: '品牌',
            dataIndex: 'brand',
            render: (text: any) => (
                text ? text.brandName : ''
            )
        },
        {
            title: '联系电话',
            dataIndex: 'phone',
        },
        {
            title: '管理员',
            dataIndex: 'isAdmin',
            render: (text: any, record: any) => (
                <Switch checkedChildren="是" unCheckedChildren="否"
                    checked={text} key={record.id}
                    onChange={(e) => ref.current.handleChangeOne(record.id, 'isAdmin', e, 'user')}
                />
            )
        },
        {
            title: '权限',
            dataIndex: 'operation',
            key: 'operation',
            render: (text: any, record: any) =>
                <Space size="small">
                    <Button size={"small"} type="primary" onClick={() => handleUserLicense(record)}>权限</Button>
                </Space>
        },
        {
            title: '特殊',
            dataIndex: 'userLicenseExpand',
            key: 'userLicenseExpand',
            render: (text: any, record: any) =>
                <Space size="small">
                    <Tooltip placement="topLeft" title={'权限（特殊）扩展'}>
                        <Button size={"small"} type="primary" onClick={() => handleUserLicenseExpand(record)}>特殊</Button>
                    </Tooltip>
                </Space>
        },
        {
            title: '配置',
            dataIndex: 'id',
            key: 'id',
            render: (val: string, record: any) =>
                <Space size="small">
                    <Tooltip placement="topLeft" title={'用户配置'}>
                        <Button size={"small"} type="primary" onClick={() => handleUserConfig(record)}>配置</Button>
                    </Tooltip>
                </Space>
        },
    ];

    /**
     * 表头
     */
    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WebUniversalProps = {
        ...props,
        titleName: '用户',
        apiId,
        columns,
        editOptions: {
            Editor: UserEdit
        }
    };

    return (
        <> <Space>
            <CustomSelect
                apiId={apiId}
                sendKeyId='userGroupId'
                getListData={userGroupData}
                sendPageData={sendPageData}
                setSendPageData={setSendPageData}
                fetchData={fetchData}
                itemName="userGroupName"
            />
            <CustomSelect
                apiId={apiId}
                sendKeyId='roleId'
                getListData={roleData}
                sendPageData={sendPageData}
                setSendPageData={setSendPageData}
                fetchData={fetchData}
                itemName="roleName"
            />
            <CustomSelect
                apiId={apiId}
                sendKeyId='brandId'
                getListData={brandData}
                sendPageData={sendPageData}
                setSendPageData={setSendPageData}
                fetchData={fetchData}
                itemName="brandName"
            />
        </Space>
            <> </>
            <WebUniversal {...extendProps} ref={ref} />
            {modalUserLicense ? (<RoleOrUserLicense
                closeModal={onCloseModalUserLicense}
                info={userInfo}
                useType={'userLicense'} />)
                : null}
            {modalUserLicenseEx ? (<RoleOrUserLicenseEx
                closeModal={onCloseModalUserLicenseEx}
                useType={'userLicense'}
                info={userInfo}
            ></RoleOrUserLicenseEx>) : null}
            {modalUserConfig ? (<UserConfigEdit
                closeModal={() => setModalUserConfig(false)}
                data={userInfo}
            ></UserConfigEdit>) : null}

        </>
    )
}

export default User;
